// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1_piN","label":"Radio_label__2ND4t","checkMark":"Radio_checkMark__A8NHb","disabled":"Radio_disabled__2Cmxq"};